<!-- <nav class="navbar navbar-expand-md navbar-light bg-dark fixed-top">
  <div class="d-flex desk-view-hide">
    <span><a class="p-2" routerLink="/"><img class="img-fluid w-50" src="assets/img/logo.png" /></a></span>
    <button class="navbar-toggler" style="background: #fff;margin: 6px;padding: 0px 4px;color: #fff;float:right;"
      type="button" data-toggle="collapse" data-target="#navbarToggler" aria-controls="navbarToggler"
      aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span></button>
  </div>
  <div class="collapse navbar-collapse" id="navbarToggler">
    <div class="container">
      <a class="navbar-brand mv-dnone" routerLink="/"><img class="img-fluid w-50" src="assets/img/logo.png" /></a>
      <ul class="navbar-nav ml-auto mt-2 mt-lg-0 mv-w100">
        <li class="nav-item mv-tborder color-gray"><a class="nav-link" routerLink="/homepage"
            [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active1">Home</a></li>
         <li class="nav-item mv-tborder"><a class="nav-link"
            style="max-width: 100px; background: #ef2c2c;color: #fff;border-radius: 3px;padding: 8px;text-align: center;"
            routerLink="/homepage/clientdeal">Deals</a></li>
        <li class="nav-item mv-tborder color-gray" *ngIf="showlogin">
          <a class="nav-link" routerLink="/firstpage" routerLinkActive="active1">Login</a>
        </li>
        <li class="nav-item mv-tborder color-gray" *ngIf="showlogin">
          <a class="nav-link" routerLink="/auth/signup/" routerLinkActive="active1">Register</a>
        </li>
        <li routerLinkActive="active1" class="nav-item dropdown mv-tborder {{userRef1 == true? 'hide' : ''}}"
          *ngIf="((user_type == 3) || (user_type == 1)  && !showlogin)">
          <a class="nav-link dropdown-toggle float-left" data-toggle="dropdown" href="javascript:void(0)"><span
              *ngIf="user.company_name">{{user.company_name}}</span></a>
          <a class="nav-link dropdown-toggle float-left" data-toggle="dropdown" href="javascript:void(0)"
            *ngIf="user.company_name == null">{{user.name}}</a>
          <a class="nav-link dropdown-toggle float-left" data-toggle="dropdown" href="javascript:void(0)"
            *ngIf="user.name == null && user.company_name == null">{{user.email}}</a>

          <div class="dropdown-menu">
            <a class="dropdown-item pl-2" routerLink="/dashboard"><i class="fa fa-briefcase mr-1"></i> Dashboard</a>
            <a class="dropdown-item pl-2" routerLink="/dashboard/viewprofile"><i class="fa fa-user-circle mr-1"></i>
              Profile</a>
            <a class="dropdown-item pl-2" routerLink="/dashboard/bookings"><i class="fa fa-calendar mr-1"></i>
              Bookings</a>
            <a class="dropdown-item pl-2" href="javascript:void(0)" (click)="logout()"><i
                class="fa fa-power-off mr-1"></i> Logout</a>
          </div>
        </li>
        <li routerLinkActive="active" class="nav-item dropdown mv-tborder {{userRef1 == true? 'hide' : ''}}"
          *ngIf="((user_type == 2) && !showlogin)">
          <a class="nav-link dropdown-toggle float-left" data-toggle="dropdown" href="javascript:void(0)"
            *ngIf="user.company_name">{{user.company_name}}</a>
          <a class="nav-link dropdown-toggle float-left" data-toggle="dropdown" href="javascript:void(0)"
            *ngIf="user.company_name == null">{{user.name}}</a>
          <a class="nav-link dropdown-toggle float-left" data-toggle="dropdown" href="javascript:void(0)"
            *ngIf="user.name == null && user.company_name == null">{{user.email}}</a>
          <div class="dropdown-menu">
            <a class="dropdown-item" routerLink="/homepage/clientprofile">Profile</a>
            <a class="dropdown-item" routerLink="/homepage/bookingclient">Booking Historry</a>
            <a class="dropdown-item" routerLink="/homepage/bookingfailed">Booking Failed</a>
            <a class="dropdown-item" href="javascript:void(0)" type='button' (click)="logout()">Logout</a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav> -->
<router-outlet></router-outlet>
<app-footer></app-footer>